var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4285 24H27.2C27.6419 24 28 23.6419 28 23.2V14.6667C28 11.7211 25.6121 9.33334 22.6667 9.33334H9.33333C6.38781 9.33334 4 11.7211 4 14.6667V23.2C4 23.6419 4.35817 24 4.8 24H8.57143",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 9.33333V4.8C10.667 4.35817 11.0252 4 11.467 4H20.5337C20.9755 4 21.3337 4.35817 21.3337 4.8V9.33333",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13026 27.0868L8.57124 24L9.23502 19.3535C9.29133 18.9595 9.62886 18.6667 10.027 18.6667H21.9726C22.3708 18.6667 22.7082 18.9595 22.7646 19.3535L23.4284 24L23.8693 27.0868C23.9382 27.5688 23.5642 28 23.0774 28H8.92222C8.43538 28 8.06141 27.5688 8.13026 27.0868Z",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 13.3467L22.6803 13.3319",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/printing.eb91766e1060be6ae864afec0ea0212c.svg";
export { ForwardRef as ReactComponent };